export default {
    getPayType: (state) => () => {
        return state.pay_type;
    },
    getPayMode: (state) => () => {
        return state.pay_mode;
    },
    getCartData: (state) => () => {
        return state.cartData;
    },
    getCartTotal: (state) => () => {
        return state.CartTotal;
    },
    getPaymentModes: (state) => () => {
        return state.payment_modes;
    },
    getLoaderStatus: (state) => () => {
        return state.showButtonLoader;
    },
    eligiblePaymentGateways: (state) => () => {

        let eligibiltyOnPayModes = null;

        if (state.pay_mode === "online_payment") {
            eligibiltyOnPayModes = state.payment_modes.online_payment;
        }
        else if (state.pay_mode === "cod_juspay") {
            eligibiltyOnPayModes = state.payment_modes.cod_juspay;
        }
        else {
            eligibiltyOnPayModes = state.payment_modes.full_payment;
        }

        return eligibiltyOnPayModes.eligiblePaymentGateways;
    },
    getmodalContent: (state) => () => {
        return state.modalContent;
    },
    getModalStatus: (state) => () => {
        return state.flagShowModal;
    },
    getIsAddressSet: (state) => () => {
        return state.is_address_set;
    },
    getProcessStatus: (state) => () => {
        return state.processStatus;
    },
    getPaymentSkeleton: (state) => () => {
        return state.paymentSkeleton;
    },
    getGatewayComponentKey: (state) => () => {
        return state.gatewayComponentKey;
    },
    getGatwayStatus: (state) => () => {
        return state.gatwayStatus;
    },
    getCreatePlanData: (state) => () => {
        return state.createPlanData;
    },
    getSplitAmt: (state) => () => {
        return state.first_split_amount;
    },
}